import React, { useState } from 'react';
import {
  Divider,
  Typography,
  Link as MUILink,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles';
import logo from '../../../../assets/Images/edit.png';
import './style.css';

export default function Footer() {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();
  const [impressumOpen, setImpressumOpen] = useState(false);

  const openImpressum = () => setImpressumOpen(true);
  const closeImpressum = () => setImpressumOpen(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* First Column */}
        <div className="footer-column1">
          <img src={logo} alt="Logo" className="logo" />
          <div className="content-description">
            <p>
              We are thrilled to have you here. zineflix is your ultimate
              destination for all your movie booking needs. Whether you're
              looking to catch the latest blockbuster, enjoy a classic film, or
              discover indie gems, we've got you covered. Our user-friendly
              platform ensures a seamless and enjoyable experience, from
              browsing movie listings to securing your tickets.
            </p>
          </div>
          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=100071265075336"
              aria-label="Facebook"
              rel="noopener noreferrer"
              target="_blank">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://x.com/Zineflix?t=JoN3UyXp6mI5hkM2QatvZQ&s=09"
              aria-label="Twitter/X"
              rel="noopener noreferrer"
              target="_blank">
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.instagram.com/zineflixofficial?utm_source=qr&igsh=MXI1emduaTY3NXF2dw=="
              aria-label="Instagram"
              rel="noopener noreferrer"
              target="_blank">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Second Column */}
        <div className="footer-column2">
          {/* First Row */}
          <div className="footer-row">
            {/* Phone */}
            <div className="footer-column3">
              <div className="icon-container phone">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <h4>Phone</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="tel:+4917656806226">
                  +49 176 56806226
                </a>
              </div>
            </div>
            {/* Address */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Address</h4>
                <p>Ahornstraße 80, 65933 Frankfurt am Main, Deutschland</p>
              </div>
            </div>
            {/* Email */}
            <div className="footer-column3">
              <div className="icon-container">
                <i className="far fa-envelope"></i>
              </div>
              <div>
                <h4>Email</h4>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href="mailto:contact@zineflix.com">
                  contact@zineflix.com
                </a>
              </div>
            </div>
          </div>

          <hr className="row-divider" />

          {/* Second Row */}
          <div className="footer-row">
            <div className="footer-column4">
              <h4 className="h4">Company</h4>
              <ul className="footer-list">
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Home</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Now Showing</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Coming Soon</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Contact Us</span>
                </li>
              </ul>
            </div>

            <div className="footer-column4">
              <h4 className="h4">Pages</h4>
              <ul className="footer-list">
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Privacy Policy</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Terms &amp; Conditions</span>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <button
                    type="button"
                    className="icon-text linklike-button"
                    onClick={openImpressum}
                    aria-haspopup="dialog"
                    aria-controls="impressum-dialog">
                    Legal Notice / Impressum
                  </button>
                </li>
                <li>
                  <i className="fas fa-dot-circle company-icon"></i>
                  <span className="icon-text">Complaints</span>
                </li>
              </ul>
            </div>

            <div className="footer-column4">
              <h4 className="h4">Newsletter</h4>
              <p>
                Sign up for our newsletter to get updated information, news, and
                free insights.
              </p>
              <div className="newsletter-input-container">
                <input
                  type="email"
                  className="newsletter-input"
                  placeholder="Enter your email"
                  aria-label="Email address"
                />
                <button className="newsletter-button">Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <Divider className="footer-divider" />

      {/* Copyright */}
      <div className="footer-copyright">
        <div className="copyright-text">
          © {currentYear} zineflix.com All rights reserved.
        </div>
        <div className="footer-links">
          <MUILink
            href="https://www.matrixmantra.lk/"
            target="_blank"
            rel="noopener noreferrer">
            Web Design &amp; Development by Matrix Mantra
          </MUILink>
        </div>
      </div>

      {/* Impressum Dialog */}
      <Dialog
        id="impressum-dialog"
        open={impressumOpen}
        onClose={closeImpressum}
        aria-labelledby="impressum-title"
        fullWidth
        maxWidth="sm">
        <DialogTitle
          disableTypography
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6" id="impressum-title">
            Legal Notice / Impressum
          </Typography>
          <IconButton aria-label="Close Impressum" onClick={closeImpressum}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <section>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Angaben gemäß § 5 TMG
            </Typography>
            <Typography
              component="address"
              style={{ fontStyle: 'normal', lineHeight: 1.8 }}>
              <strong>Zineflix</strong>
              <br />
              Hr. Sivarsan Tharmaratnam
              <br />
              Ahornstraße 80
              <br />
              65933 Frankfurt am Main
              <br />
              Deutschland
            </Typography>
          </section>

          <section style={{ marginTop: 16 }}>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Kontakt
            </Typography>
            <Typography>
              Telefon:{' '}
              <a style={{ color: 'gold' }} href="tel:+4917656806226">
                +49 176 56806226
              </a>
              <br />
              E‑Mail:{' '}
              <a style={{ color: 'gold' }} href="mailto:contact@zineflix.com">
                contact@zineflix.com
              </a>
              <br />
              Website:{' '}
              <a
                style={{ color: 'gold' }}
                href="https://www.zineflix.com"
                target="_blank"
                rel="noopener noreferrer">
                www.zineflix.com
              </a>
            </Typography>
          </section>

          <section style={{ marginTop: 16 }}>
            <Typography variant="subtitle1" component="h3" gutterBottom>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </Typography>
            <Typography
              component="address"
              style={{ fontStyle: 'normal', lineHeight: 1.8 }}>
              Hr. Sivarsan Tharmaratnam
              <br />
              Ahornstraße 80
              <br />
              65933 Frankfurt am Main
              <br />
              Deutschland
            </Typography>
          </section>
        </DialogContent>
      </Dialog>
    </footer>
  );
}
